import { UsaStates } from 'usa-states'

const states = new UsaStates().states.map(({ name }) => ({
  label: name,
  value: name,
}))

export { states }
